// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CreatorCardMiniWithTolgee [class*=dist_container-card-tooltip-trending] {
  width: 24px !important;
  height: 24px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/CreatorCardMiniWithTolgee/index.scss"],"names":[],"mappings":"AACE;EACE,sBAAA;EACA,uBAAA;AAAJ","sourcesContent":[".CreatorCardMiniWithTolgee {\n  [class*='dist_container-card-tooltip-trending'] {\n    width: 24px !important;\n    height: 24px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
